import React, { useState } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import StickyBox from "react-sticky-box";
import ContentPage from "../../components/layout/contentPage";
import { doctorBanner } from "../../constants/images";
import { Col, List, ListItem, Row, Text, Title, VImage } from "../../style/base.style";
import { servicePlans } from "../../assets/constant/services";
import { useDictionary } from "../../contexts/dictionary";
import { TextLink } from "../../components/common/TextLink";
import { ActionButton, ButtonStyle } from "../../components/buttons/ActionButton";
import { useDeviceType } from "../../contexts/DeviceContext";
import { ServiceBenefits } from "./serviceBenefits";





export const ServicesDetailsPage = () => {
    const {translate} = useDictionary();
    const {isMobile} = useDeviceType();
    const navigate = useNavigate();


    const { id } = useParams<{ id: string }>();
    const service = servicePlans.find((service) => service.id === Number(id));
    if (!service) {
        return <div>service not found</div>;
    }

    const goBack = () => {
        navigate(-1);
    }

    const downloadFile = (id: number) => {
        
        window.location.href = `/files/${id}.pdf`;
    };
    

  return (
    <div className="main-wrapper">
        <ContentPage title={translate("services")}>
        
        <Col $gap={20} $margin="20px 0px" $width={isMobile?"90%":"75%"} $alignSelf="center">
            <Row $width="100%" $justifyContent="flex-start" className="reer">
                <TextLink fontSize="16px" onClick={goBack} hasLine={true} >{translate('go_back')}</TextLink>
            </Row>
        
        
        
            <Row $width="100%" >
         
            <Col $width="100%" $gap={20}>
            {/* <div className="col-md-12 col-lg-8 col-xl-9"> */}
        
              {/* Doctor Widget */}
              <Col $width="100%" $backgroundColor="#fff" $border="1px solid #e0e0e0" $borderRadius={10} $gap={20}>
           
                
                <Row $justifyContent={isMobile?"center":"space-between"} $width="100%">
                    <Col $width={isMobile?"100%":"70%"} $gap={10} $alignItems="flex-start">
                    <Row $gap={10}>
                        <Col $alignSelf="flex-start" $width="200px" $justifyContent="center" $padding="20px 0px">
                            
                                <Link to={`/services/${service.id}`}>
                                <VImage
                                    $width={'200px'}
                                    src={service.img}
                                    className="img-fluid"
                                    alt="User Image"
                                    $borderRadius="10px"
                                />
                                </Link>
                            
                        </Col>
                        <Col $width="70%">
                        <div className="doc-info-cont">
                            <h4 className="doc-name mb-2">
                            <Link to={`/services/${service.id}`}>
                                {translate(service.name)}
                            </Link>
                            </h4>
                            <div className="rating mb-2">
                            <span className="badge badge-primary">{service.rate.toFixed(1)}</span>
                            {Array.from({ length: Math.floor(service.rate) }).map((_, i) => (
                                        <i key={i} className="fas fa-star filled" />))}

                                {Array.from({ length: Math.floor(5-service.rate) }).map((_, i) => (
                                        <i key={i} className="fas fa-star"/>))}
                            
                            
                            <span className="d-inline-block average-rating ms-1">
                                ({service.votes})
                            </span>
                            </div>
                         <Text>{translate(service.description)}</Text>
                        </div>
                        </Col>
                    </Row>
       
                    </Col>
                    <Col $alignSelf="flex-end" $padding="20px" $gap={10}>
                         <ActionButton style={ButtonStyle.light} width="125px" onClick={()=>downloadFile(service.id)} label={translate('download')} />
                         <ActionButton width="125px" route={`/services/${service.id}`} label={translate('join_now')} />
                    </Col>
             
              
                </Row>
                
             
            
              </Col>
              
             
              <Col $width="100%" $backgroundColor="#fff" $border="1px solid #e0e0e0" $borderRadius={10} $gap={20} $alignItems="flex-start">
               <div className="card-body">
                
                   <Row $justifyContent={isMobile?"center":"space-between"} $width="100%" $padding="20px">
                       <Col $alignItems="flex-start">
                            <Title $fontSize={24}>{translate('what_is_included')}</Title>
                            <ServiceBenefits benefits={service.benefits} hideButton={true} />
                       </Col>
                
                 
                   </Row>
                   
                
               </div>
             </Col>
              {/* /Doctor Widget */}
        
           
            {/* </div> */}
            </Col>
          
            </Row>
         
        
        </Col>

        </ContentPage>
    

    </div>
  );
};


